'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

// This regex expression allows numbers, -, +, [], (), and \s (spaces)
var phoneRegex = /^[0-9()\-\+\[\]\s]+$/;

// phoneRegex.test('+ 100') === true
// phoneRegex.test('(123)123-1234') === true
// phoneRegex.test('1-123-123-1234') === true
// phoneRegex.test('+63 (100) 1235-1234') === true
// phoneRegex.test('+65-1000-1234') === true
// phoneRegex.test('+65 1000 1234') === true

module.exports = buildSimpleValidator(function (value) {
  return phoneRegex.test(value);
}, 'Value must be a phone number');